import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

export const formatPlaka = (value) => {
    const cleaned = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    let result = '';
    const numbers = cleaned.match(/\d+/g) || [];
    const letters = cleaned.match(/[A-Z]+/g) || [];
    if (numbers.length > 0) result += numbers[0].substring(0, 2);
    if (letters.length > 0) { if (result.length > 0) result += ' '; result += letters[0].substring(0, 3); }
    if (numbers.length > 1) { if (result.length > 0 && !result.endsWith(' ')) result += ' '; result += numbers[1].substring(0, 4); }
    return result;
};

// Faz 4.5 (2026-08-29): tüm kullanıcı metin girdileri tamamı BÜYÜK HARF kuralına geçti.
// Ad "capitalizeWords" çağıran yerler bozulmasın diye korunuyor; davranış artık tam büyütme.
export const capitalizeWords = (text) => {
    if (!text) return '';
    return text.toLocaleUpperCase('tr-TR');
};

export const checkCustomer = async (phone, setMusteriId, setMusteriDurumu, setAdSoyad, currentAdSoyad) => {
    if (!phone || phone.length < 10) {
        setMusteriId(null);
        setMusteriDurumu('');
        return;
    }
    try {
        const phoneQuery = query(collection(db, "customers"), where("telefon", "==", phone));
        const phoneSnapshot = await getDocs(phoneQuery);

        if (!phoneSnapshot.empty) {
            const customer = phoneSnapshot.docs[0];
            setMusteriId(customer.id);
            setMusteriDurumu('mevcut');
            if (!currentAdSoyad && customer.data().adSoyad) {
                setAdSoyad(customer.data().adSoyad);
            }
        } else {
            setMusteriId(null);
            setMusteriDurumu('yeni');
        }
    } catch (error) {
        console.error("Müşteri kontrolü hatası:", error);
    }
};

export const formatTarih = (timestamp) => {
    if (!timestamp) return '-';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const formatTarihSaat = (timestamp) => {
    if (!timestamp) return '-';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const formatCurrency = (amount) => {
    return (amount ?? 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
};
